function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import TextBoxWithLabel from '../../molecules/TextBoxWithLabel';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';
import FocusTrap from '../../atoms/FocusTrap/FocusTrap';
var KEY_ESC = 27;
export default function MenuSearch(_ref) {
  var onSubmit = _ref.onSubmit,
      searchLabel = _ref.searchLabel,
      searchButtonLabel = _ref.searchButtonLabel,
      searchButtonAbortText = _ref.searchButtonAbortText;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchQuery = _useState4[0],
      setSearchQuery = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var searchBoxRef = useRef();
  var openSearchButton = useRef();
  useEffect(function () {
    document.addEventListener('keydown', handleKeyDown);
    return function () {
      return document.removeEventListener('keydown', handleKeyDown);
    };
  });

  var handleKeyDown = function handleKeyDown(event) {
    if (event.keyCode === KEY_ESC && focused) closeSeachBox();
  };

  var closeSeachBox = function closeSeachBox() {
    setFocused(false);
    if (openSearchButton.current) openSearchButton.current.focus();
  };

  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    if (onSubmit) onSubmit(e, searchQuery);
    setLoading(true);
  };

  var renderSearchField = function renderSearchField(Component) {
    var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: "menu__search--open",
      ref: searchBoxRef
    }, additionalProps), /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit,
      className: "menu__search--open-form"
    }, /*#__PURE__*/React.createElement(TextBoxWithLabel, {
      type: "search",
      autoFocus: true,
      withIcon: true,
      iconName: "ico_search",
      iconLabel: searchButtonLabel,
      disabled: loading,
      iconIsButton: true,
      onIconClick: onSubmit,
      displayLoader: loading,
      small: true,
      hideLabel: true,
      labelText: searchLabel,
      value: searchQuery,
      onChange: function onChange(e) {
        return setSearchQuery(e.target.value);
      }
    })), /*#__PURE__*/React.createElement("button", {
      className: "menu__search--open-abort-button button button--small",
      onClick: function onClick() {
        return closeSeachBox();
      },
      "aria-label": searchButtonAbortText ? searchButtonAbortText : 'Lukk'
    }, searchButtonAbortText ? searchButtonAbortText : 'Lukk'));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('menu__search', {
      'menu__search--focused': focused
    })
  }, /*#__PURE__*/React.createElement("button", {
    ref: openSearchButton,
    className: "menu__search button--stripped",
    onClick: function onClick() {
      return setFocused(true);
    },
    "aria-label": searchButtonLabel ? searchButtonLabel : 'Søk'
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    className: "menu__search--icon",
    iconName: "ico_search-menu",
    color: "none"
  }), /*#__PURE__*/React.createElement("div", {
    className: "menu__search--label",
    "aria-label": searchButtonLabel ? searchButtonLabel : 'Søk'
  }, searchButtonLabel ? searchButtonLabel : 'Søk')), focused && renderSearchField(FocusTrap, {
    as: 'div'
  }));
}